<app-standard-table class="flex-1 flex flex-col min-h-0" [title]="'admin.accountList'" [columns]="columnList"
  [data]="tableDataFilters" [totalItems]="totalItems" [pageSize]="pageSize" [isLoading]="isLoading"
  [currentPage]="currentPage" (searchChange)="search($event)" (sortChange)="onSort($event)"
  (pageChange)="onPageChange($event)" (rowClick)="onClickRow($event)" (create)="openCreateModal()"
  (edit)="onEdit($event)" (delete)="onDelete($event)"></app-standard-table>


<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
  <div class="modal-content animate-reveal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="header-title-group">
       
        <h3>{{ (isEditMode ? 'modal.editAccount' : 'modal.createAccount') | translate }}</h3>
      </div>
      <button class="close-icon" (click)="closeModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <form (ngSubmit)="submit()" #accountForm="ngForm">
      <div class="form-body">
        <div class="qr-upload-section">
          <div class="image-upload-container group" (click)="filePick.click()">
            <input type="file" #filePick (change)="onFileSelected($event)" accept="image/*" class="hidden">
            
            <div *ngIf="!imagePreview" class="upload-placeholder">
             
              <span class="upload-text">{{ 'modal.QR' | translate }}</span>
            </div>

            <div *ngIf="imagePreview" class="image-preview-wrapper shadow-sm">
              <img [src]="imagePreview" alt="Image Preview" class="image-preview">
              <div class="image-overlay">
                <i class="fas fa-camera"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="fields-grid" style="grid-template-columns: 1fr;">
          <div class="form-group">
            <label for="name">
              {{ 'modal.name' | translate }}
            </label>
            <div class="input-wrapper">
              <input id="name" name="name" type="text" [(ngModel)]="newAccount.name"
                [placeholder]="'modal.enterName' | translate" class="form-input" />
            </div>
          </div>
          <div class="form-group">
            <label for="phone">
              {{ 'modal.phone' | translate }}
            </label>
            <div class="input-wrapper">
              <input id="phone" name="phone" type="text" [(ngModel)]="newAccount.phone"
                [placeholder]="'modal.enterPhone' | translate" class="form-input" />
            </div>
          </div>
          <div class="form-group">
            <label for="card">
              {{ 'modal.card' | translate }}
            </label>
            <div class="input-wrapper">
              <select id="card" name="card" [(ngModel)]="newAccount.cardid" class="form-input">
                <option *ngFor="let card of cards" [value]="card.id">
                  {{ card.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn-cancel" (click)="closeModal()" [disabled]="isSaving">
          {{ 'admin.cancel' | translate }}
        </button>
        <button type="submit" class="btn-submit" [disabled]="!newAccount.cardid || isSaving">
          <div class="btn-content" [class.loading]="isSaving">
            <span *ngIf="!isSaving">{{ (isEditMode ? 'modal.updateAccount' : 'modal.createAccountBtn') | translate }}</span>
            <span *ngIf="isSaving" class="spinner-group">
              <i class="fas fa-circle-notch fa-spin"></i>
              {{ 'modal.saving' | translate }}
            </span>
          </div>
        </button>
      </div>
    </form>
  </div>
</div>

<div class="confirm-overlay" *ngIf="isDeleteConfirmOpen" (click)="cancelDelete()">
  <div class="confirm-box animate-pop" (click)="$event.stopPropagation()">
    <div class="confirm-icon-wrapper">
      <div class="confirm-icon">
        <i class="fas fa-trash-alt"></i>
      </div>
    </div>
    <div class="confirm-body">
      <h3 class="confirm-title">{{ 'alert.deleteConfirm' | translate }}</h3>
      <p class="confirm-subtitle">This action cannot be undone.</p>
    </div>
    <div class="confirm-actions">
      <button class="confirm-cancel-btn" (click)="cancelDelete()">
        <i class="fas fa-times"></i>
        {{ 'admin.cancel' | translate }}
      </button>
      <button class="confirm-delete-btn" (click)="confirmDelete()">
        <i class="fas fa-trash-alt"></i>
        Delete
      </button>
    </div>
  </div>
</div>